export const validLensMaterialColumns = [
    {
        Header: "Name",
        accessor: "name",
        canFilter: true,
        filterPlaceholder: "Filter by name",
        width: 250,
    },
    {
        Header: "Status",
        accessor: "status",
        canFilter: true,
        filterPlaceholder: "Filter by status",
        width: 100,
    },
    {
        Header: "Notes",
        accessor: "notes",
        width: 350,
    },
];
